export default "__VITE_ASSET__34jaMdv0__"